import styled from 'styled-components';

export const ButtonsHolder = styled.div((props) => ({
  display: 'flex',
  justifyContent: props.justifyContent || 'space-between',
  padding: '16px 24px',
  width: '100%',
}));
